import React from "react";
import { Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getCronStatusPanelSx } from "../theme/panelStyles";

const CronStatusPanel = ({
  isActive,
  title = "Status Information",
  children,
  sx = {},
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{ ...getCronStatusPanelSx(theme, isActive), ...sx }}
    >
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        gutterBottom
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  );
};

export default CronStatusPanel;
